// extracted by mini-css-extract-plugin
module.exports = {"close-button":"close-button_close-button__EGX2J","close-button-wrapper":"close-button_close-button-wrapper__NusZH","warning-text":"close-button_warning-text__12PG0"};